import { Link } from 'apps/shared/scripts/components';
import { SignatureFragment } from 'apps/shared/scripts/graphql/fragments/SignatureFragment.generated';

import SignatureItemBody from './SignatureItemBody';
import SignatureItemFooter from './SignatureItemFooter';
import SignatureItemHeader from './SignatureItemHeader';
import { signatureItemClassName } from './styles';

type Props = SignatureFragment;

const SignatureItem = ({ card, timestamp }: Props) => {
  return (
    <Link className={signatureItemClassName} to={`/${card.id}?rd=1`}>
      <SignatureItemHeader recipientName={card.recipientName} />
      <SignatureItemBody headline={card.headline} />
      <SignatureItemFooter signedAt={timestamp} />
    </Link>
  );
};

SignatureItem.displayName = 'SignatureItem';

export default SignatureItem;
